import { put, call, delay } from 'redux-saga/effects';
import addFilterQueryWithCondition from '../../../utils/addFilterQueryWithCondition';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { BACKEND_URL, DEFAULT_ITEMS_OF_PAGE, LOADING_DELAY } from '../../../configs';
import makeRequest from '../../../utils/makeRequest';
import { OK } from '../../../configs/serverStatusCodes';
import processError from '../../../utils/processError';
import { loadListFailed, loadListSuccessful, loadListBegin } from '../actions';

export default function* loadList(action) {
  try {
    const { payload = {} } = action;
    const {
      limit = 50,
      page = 1,
      filter,
    } = payload;
    let pool = {
      limit,
      page,
    };
    if (typeof filter === 'object' && Object.keys(filter).length) {
      yield delay(LOADING_DELAY);
      pool = addFilterQueryWithCondition(filter, pool);
    }
    yield put(loadListBegin());
    const url = `${BACKEND_URL}/users`;
    const dataResponse = yield makeRequest(url, pool, action, 'GET', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK && data) {
      yield put(loadListSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadListFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadListFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}
